(function() {
if (customElements.get('archelia-dynamic-menu')) return;

class ArcheliaDynamicMenu extends HTMLElement {
  constructor() {
    super();
    this.tree = [];
    this.activeCategoryHandle = null;
    this.activeFamilyHandle = null;
    this.mobileLevel = 'families'; // 'families' | 'subfamilies'
    this.isLoading = true;
    this.token = this.getAttribute('data-token') || '5625623cd9693cf0ace407f6ec09b740';
    this.storeDomain = this.getAttribute('data-domain') || 'archelia-2.myshopify.com';
    this.cacheKey = 'archelia_web_menu_cache_v4';
    this.cacheTimeKey = 'archelia_web_menu_time_v4';
    this.hasPromos = this.getAttribute('data-has-promos') === 'true';
    this.hasFlash = this.getAttribute('data-has-flash') === 'true';
    this.mobileBreakpoint = 990;
  }

  connectedCallback() {
    // Force drawer width (bypass CDN CSS cache)
    const drawer = this.closest('.archelia-drawer');
    if (drawer) {
      if (!this.isMobile()) {
        drawer.style.width = '950px';
        drawer.style.maxWidth = '90vw';
      }
    }

    this.style.display = 'block';
    this.style.height = '100%';
    this.style.width = '100%';
    this.style.overflow = 'hidden';
    this.style.minHeight = '0';
    this.innerHTML = `
      <div id="archelia-menu-wrapper" style="display: flex; flex-direction: row; height: 100%; width: 100%; background: #ffffff; overflow: hidden; position: relative;">
        <div id="archelia-menu-loading" style="padding: 20px; font-size: 14px; color: #1B2141;">Caricamento catalogo...</div>
        <div id="archelia-menu-sidebar" style="display: none; width: 250px; background: #F7F7F7; overflow-y: auto; overflow-x: hidden; border-right: 1px solid #EDEDED; height: 100%; padding-bottom: 20px; flex-shrink: 0;"></div>
        <div id="archelia-menu-families" style="display: none; width: 300px; background: #FFFFFF; overflow-y: auto; overflow-x: hidden; height: 100%; padding-bottom: 20px; border-right: 1px solid #EDEDED; flex-shrink: 0;"></div>
        <div id="archelia-menu-subfamilies" style="display: none; flex: 1; min-width: 350px; background: #FAFAFA; overflow-y: auto; overflow-x: hidden; height: 100%; padding-bottom: 20px; flex-shrink: 0;"></div>
      </div>
    `;
    this.initFetch();
  }

  isMobile() {
    return window.innerWidth < this.mobileBreakpoint;
  }

  async initFetch() {
    const cached = localStorage.getItem(this.cacheKey);
    const cacheTime = localStorage.getItem(this.cacheTimeKey);
    if (cached && cacheTime && (Date.now() - Number(cacheTime)) < 1000 * 60 * 60 * 24) {
      this.tree = JSON.parse(cached);
      this.isLoading = false;
      this.renderMenu();
      return;
    }

    try {
      let hasNextPage = true;
      let cursor = null;
      let allCollections = [];

      while (hasNextPage) {
        const query = `
          query getAllCollections($after: String) {
            collections(first: 250, after: $after) {
              pageInfo { hasNextPage endCursor }
              edges {
                node {
                  id
                  title
                  handle
                  nascondiMenu: metafield(namespace: "archelia", key: "nascondi_menu") {
                    value
                  }
                  products(first: 1) { edges { node { id } } }
                }
              }
            }
          }
        `;
        const res = await fetch(`https://${this.storeDomain}/api/2024-04/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.token
          },
          body: JSON.stringify({ query, variables: { after: cursor } })
        });
        
        const json = await res.json();
        const data = json.data.collections;
        allCollections.push(...data.edges.map(e => e.node));
        
        hasNextPage = data.pageInfo.hasNextPage;
        cursor = data.pageInfo.endCursor;
      }

      this.tree = this.buildMenuTree(allCollections);
      localStorage.setItem(this.cacheKey, JSON.stringify(this.tree));
      localStorage.setItem(this.cacheTimeKey, Date.now().toString());

    } catch (err) {
      console.error('Archelia Menu Error:', err);
      this.querySelector('#archelia-menu-loading').innerHTML = "Errore di connessione catalogo.";
    } finally {
      this.isLoading = false;
      this.renderMenu();
    }
  }

  buildMenuTree(collections) {
    const validCollections = collections.filter(c => {
      const isSystem = ['frontpage', 'all'].includes(c.handle);
      const isHidden = c.nascondiMenu && c.nascondiMenu.value === 'true';
      return !isSystem && !isHidden;
    });

    const sorted = [...validCollections].sort((a, b) => a.handle.length - b.handle.length);
    const tree = [];
    const nodeMap = new Map();
    const DEFAULT_ICONS = ['box', 'tool', 'sun', 'home', 'radio', 'battery', 'feather', 'droplet'];
    let rootIndex = 0;

    const brandsNode = { title: "Marche", handle: "marche", icon: "award", families: [] };
    let hasBrands = false;

    for (const c of sorted) {
      const pEdges = c.products && c.products.edges ? c.products.edges : [];
      const hasProducts = pEdges.length > 0;

      if (c.handle.startsWith('marca-') && c.handle !== 'marca') {
        if (hasProducts) {
          hasBrands = true;
          brandsNode.families.push({ title: c.title, handle: c.handle, families: [], hasProducts });
        }
        continue;
      }

      let parentNode = null;
      let parentHandleFound = "";

      for (const [existingHandle, node] of nodeMap.entries()) {
        if (c.handle.startsWith(existingHandle + '-') && existingHandle.length > parentHandleFound.length) {
          parentHandleFound = existingHandle;
          parentNode = node;
        }
      }

      const newNode = { title: c.title, handle: c.handle, families: [], hasProducts };

      if (parentNode) {
        parentNode.families.push(newNode);
      } else {
        newNode.icon = DEFAULT_ICONS[rootIndex % DEFAULT_ICONS.length];
        rootIndex++;
        tree.push(newNode);
      }
      
      nodeMap.set(c.handle, newNode);
    }

    function pruneEmptyBranches(nodes) {
      return nodes.filter(node => {
        if (node.families) {
          node.families = pruneEmptyBranches(node.families);
        }
        return node.hasProducts || (node.families && node.families.length > 0);
      });
    }

    const prunedTree = pruneEmptyBranches(tree);

    if (hasBrands) {
      brandsNode.families.sort((a, b) => a.title.localeCompare(b.title));
      prunedTree.push(brandsNode);
    }

    return prunedTree;
  }

  getSvgIcon(name, size=24) {
    const svgs = {
      'box': '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
      'tool': '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>',
      'sun': '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>',
      'home': '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>',
      'radio': '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>',
      'battery': '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>',
      'feather': '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5l6.74-6.76z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>',
      'droplet': '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>',
      'award': '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>',
      'chevron-right': '<polyline points="9 18 15 12 9 6"></polyline>',
      'arrow-left': '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>'
    };
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${svgs[name] || svgs['box']}</svg>`;
  }

  // ============================
  // MAIN RENDER
  // ============================
  renderMenu() {
    this.querySelector('#archelia-menu-loading').style.display = 'none';
    const sidebar = this.querySelector('#archelia-menu-sidebar');
    const families = this.querySelector('#archelia-menu-families');
    const subfamilies = this.querySelector('#archelia-menu-subfamilies');

    sidebar.style.display = 'block';
    families.style.display = 'block';

    if (this.tree.length > 0 && !this.activeCategoryHandle) {
      this.activeCategoryHandle = this.tree[0].handle;
    }

    // Auto-select first family of the active category
    if (this.activeCategoryHandle && !this.activeFamilyHandle) {
      const activeRoot = this.tree.find(c => c.handle === this.activeCategoryHandle);
      if (activeRoot && activeRoot.families.length > 0) {
        this.activeFamilyHandle = activeRoot.families[0].handle;
      }
    }

    this.applyLayout();
    this.renderSidebar(sidebar);
    this.renderFamilies(families);
    this.renderSubfamilies(subfamilies);
  }

  applyLayout() {
    const sidebar = this.querySelector('#archelia-menu-sidebar');
    const families = this.querySelector('#archelia-menu-families');
    const subfamilies = this.querySelector('#archelia-menu-subfamilies');
    const wrapper = this.querySelector('#archelia-menu-wrapper');

    if (this.isMobile()) {
      // Mobile layout
      if (this.mobileLevel === 'subfamilies') {
        // Fullscreen takeover per le subfamiglie
        sidebar.style.display = 'none';
        families.style.display = 'none';
        subfamilies.style.display = 'block';
        subfamilies.style.width = '100%';
        subfamilies.style.borderRight = 'none';
      } else {
        // Vista standard: sidebar + famiglie
        sidebar.style.display = 'block';
        sidebar.style.width = '30%';
        families.style.display = 'block';
        families.style.width = '70%';
        families.style.borderRight = 'none';
        subfamilies.style.display = 'none';
      }
    } else {
      // Desktop layout: 3 colonne fisse
      sidebar.style.display = 'block';
      sidebar.style.width = '25%';
      families.style.display = 'block';
      families.style.width = '35%';
      families.style.borderRight = '1px solid #EDEDED';
      subfamilies.style.display = 'block';
      subfamilies.style.width = '40%';
    }
  }

  // ============================
  // SIDEBAR (Livello 1 — Categorie Root)
  // ============================
  renderSidebar(sidebar) {
    let html = '<ul style="list-style: none; padding: 0; margin: 0;">';
    
    // Offerte dinamiche
    if (this.hasPromos) {
      html += `
        <li style="padding: 20px 10px; border-bottom: 1px solid #CBD5E1; text-align: center;">
          <a href="/pages/offerte" style="color: #F5A623; font-weight: 800; text-transform: uppercase; text-decoration: none; font-size: 11px; display: flex; flex-direction: column; align-items: center;">
            <div style="margin-bottom: 6px; font-size: 24px;">&#128293;</div>
            Offerte
          </a>
        </li>
      `;
    }
    
    if (this.hasFlash) {
      html += `
        <li style="padding: 20px 10px; border-bottom: 1px solid #CBD5E1; text-align: center;">
          <a href="/pages/offerte-del-giorno" style="color: #F5A623; font-weight: 800; text-transform: uppercase; text-decoration: none; font-size: 11px; display: flex; flex-direction: column; align-items: center;">
            <div style="margin-bottom: 6px; font-size: 24px;">&#9889;</div>
            Offerte del Giorno
          </a>
        </li>
      `;
    }

    for (const macro of this.tree) {
      const isActive = this.activeCategoryHandle === macro.handle;
      const bg = isActive ? '#FFFFFF' : 'transparent';
      const color = isActive ? '#008394' : '#1B2141';
      html += `
        <li style="background: ${bg}; padding: 22px 10px; cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; border-bottom: 1px solid #CBD5E1;${isActive ? ' border-right: 3px solid #008394;' : ''}" data-handle="${macro.handle}" class="archelia-macro-item">
          <div style="color: ${color}; margin-bottom: 8px;">
            ${this.getSvgIcon(macro.icon || 'box', 26)}
          </div>
          <span style="color: ${color}; font-size: 11px; font-weight: ${isActive ? '800' : '600'}; text-transform: uppercase; line-height: 1.3;">
            ${macro.title}
          </span>
        </li>
      `;
    }
    html += '</ul>';
    sidebar.innerHTML = html;

    const items = sidebar.querySelectorAll('.archelia-macro-item');
    items.forEach(el => {
      el.addEventListener('click', () => {
        this.activeCategoryHandle = el.getAttribute('data-handle');
        // Auto-select prima famiglia
        const root = this.tree.find(c => c.handle === this.activeCategoryHandle);
        if (root && root.families.length > 0) {
          this.activeFamilyHandle = root.families[0].handle;
        } else {
          this.activeFamilyHandle = null;
        }
        this.mobileLevel = 'families';
        this.renderMenu();
      });
    });
  }

  // ============================
  // FAMILIES (Livello 2 — Famiglie)
  // ============================
  renderFamilies(container) {
    const activeRoot = this.tree.find(c => c.handle === this.activeCategoryHandle);
    if (!activeRoot) {
      container.innerHTML = '';
      return;
    }

    let html = `
      <div style="padding: 16px 16px 8px;">
        <h3 style="margin: 0 0 4px; font-size: 17px; color: #1B2141; font-weight: 700;">${activeRoot.title}</h3>
      </div>
    `;

    if (activeRoot.families && activeRoot.families.length > 0) {
      html += '<ul style="list-style: none; padding: 0; margin: 0;">';

      for (const fam of activeRoot.families) {
        const isActive = this.activeFamilyHandle === fam.handle;
        const hasChildren = fam.families && fam.families.length > 0;

        html += `
          <li style="border-bottom: 1px solid #F1F5F9;">
            <div class="archelia-family-item" data-handle="${fam.handle}" data-has-children="${hasChildren}" style="
              display: flex; align-items: center; justify-content: space-between;
              padding: 12px 16px; cursor: pointer;
              background: ${isActive ? '#F0F9FA' : 'transparent'};
              border-left: 3px solid ${isActive ? '#008394' : 'transparent'};
              transition: background 0.15s ease;
            ">
              <span style="font-size: 14px; font-weight: ${isActive ? '700' : '600'}; color: ${isActive ? '#008394' : '#1B2141'};">
                ${fam.title}
              </span>
              ${hasChildren ? `<span style="color: ${isActive ? '#008394' : '#999'}; flex-shrink: 0; margin-left: 8px;">${this.getSvgIcon('chevron-right', 16)}</span>` : ''}
            </div>
          </li>
        `;
      }

      html += '</ul>';

      // Link "Vedi tutto il reparto"
      html += `
        <div style="padding: 16px; border-top: 1px solid #EDEDED;">
          <a href="/collections/${activeRoot.handle}" style="display: flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 700; color: #008394; text-decoration: none;">
            Vedi tutto ${activeRoot.title}
            <span>${this.getSvgIcon('chevron-right', 14)}</span>
          </a>
        </div>
      `;
    } else {
      // Nessuna famiglia — pulsante diretto
      html += `
        <div style="padding: 16px;">
          <a href="/collections/${activeRoot.handle}" style="display: inline-block; background: #008394; color: #ffffff; padding: 10px 16px; border-radius: 4px; text-decoration: none; font-size: 14px; font-weight: bold;">
            Esplora intero reparto
          </a>
        </div>
      `;
    }

    container.innerHTML = html;
    container.scrollTop = 0;

    // Event listeners per famiglie
    const familyItems = container.querySelectorAll('.archelia-family-item');
    familyItems.forEach(el => {
      // Hover effect
      el.addEventListener('mouseenter', () => {
        if (el.getAttribute('data-handle') !== this.activeFamilyHandle) {
          el.style.background = '#F8FAFB';
        }
      });
      el.addEventListener('mouseleave', () => {
        if (el.getAttribute('data-handle') !== this.activeFamilyHandle) {
          el.style.background = 'transparent';
        }
      });

      el.addEventListener('click', () => {
        const handle = el.getAttribute('data-handle');
        const hasChildren = el.getAttribute('data-has-children') === 'true';

        if (!hasChildren) {
          // Link diretto se non ci sono sottofamiglie
          window.location.href = `/collections/${handle}`;
          return;
        }

        this.activeFamilyHandle = handle;

        if (this.isMobile()) {
          this.mobileLevel = 'subfamilies';
        }

        this.renderMenu();
      });
    });
  }

  // ============================
  // SUBFAMILIES (Livello 3 — Sottofamiglie)
  // ============================
  renderSubfamilies(container) {
    // Trova la famiglia attiva
    const activeRoot = this.tree.find(c => c.handle === this.activeCategoryHandle);
    if (!activeRoot) {
      container.innerHTML = '';
      return;
    }

    const activeFamily = activeRoot.families
      ? activeRoot.families.find(f => f.handle === this.activeFamilyHandle)
      : null;

    if (!activeFamily || !activeFamily.families || activeFamily.families.length === 0) {
      if (!this.isMobile()) {
        // Desktop: mostra messaggio vuoto o link diretto
        if (activeFamily) {
          container.innerHTML = `
            <div style="padding: 24px 16px; text-align: center;">
              <p style="color: #666; font-size: 14px; margin: 0 0 16px;">Nessuna sottocategoria</p>
              <a href="/collections/${activeFamily.handle}" style="display: inline-block; background: #008394; color: #fff; padding: 10px 20px; border-radius: 4px; text-decoration: none; font-size: 14px; font-weight: 600;">
                Vedi ${activeFamily.title}
              </a>
            </div>
          `;
        } else {
          container.innerHTML = '';
        }
      }
      return;
    }

    let html = '';

    // Mobile: header con pulsante indietro
    if (this.isMobile() && this.mobileLevel === 'subfamilies') {
      html += `
        <div id="archelia-back-btn" style="
          display: flex; align-items: center; gap: 10px;
          padding: 14px 16px; background: #232F3E; color: #FFFFFF;
          cursor: pointer; font-size: 15px; font-weight: 700;
          position: sticky; top: 0; z-index: 2;
        ">
          ${this.getSvgIcon('arrow-left', 20)}
          <span>${activeFamily.title}</span>
        </div>
      `;
    } else {
      // Desktop: header semplice
      html += `
        <div style="padding: 16px 16px 8px;">
          <h4 style="margin: 0 0 4px; font-size: 16px; color: #1B2141; font-weight: 700;">${activeFamily.title}</h4>
        </div>
      `;
    }

    // Lista sottofamiglie
    html += '<ul style="list-style: none; padding: 0; margin: 0;">';

    for (const sub of activeFamily.families) {
      html += `
        <li style="border-bottom: 1px solid #F1F5F9;">
          <a href="/collections/${sub.handle}" style="
            display: flex; align-items: center; justify-content: space-between;
            padding: 12px 16px; font-size: 14px; color: #475569;
            text-decoration: none; transition: background 0.15s ease, color 0.15s ease;
          " onmouseenter="this.style.background='#EEF2FF';this.style.color='#008394';"
             onmouseleave="this.style.background='transparent';this.style.color='#475569';">
            <span>${sub.title}</span>
            <span style="color: #CBD5E1; flex-shrink: 0;">${this.getSvgIcon('chevron-right', 14)}</span>
          </a>
        </li>
      `;
    }

    html += '</ul>';

    // Link "Vedi tutto" della famiglia
    html += `
      <div style="padding: 16px; border-top: 1px solid #EDEDED;">
        <a href="/collections/${activeFamily.handle}" style="display: flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 700; color: #008394; text-decoration: none;">
          Vedi tutto ${activeFamily.title}
          <span>${this.getSvgIcon('chevron-right', 14)}</span>
        </a>
      </div>
    `;

    container.innerHTML = html;
    container.scrollTop = 0;

    // Mobile: event listener per pulsante indietro
    if (this.isMobile() && this.mobileLevel === 'subfamilies') {
      const backBtn = container.querySelector('#archelia-back-btn');
      if (backBtn) {
        backBtn.addEventListener('click', () => {
          this.mobileLevel = 'families';
          this.renderMenu();
        });
      }
    }
  }
}

customElements.define('archelia-dynamic-menu', ArcheliaDynamicMenu);
})();
